/**
 * @generated SignedSource<<9bdf869bc79d9a8abedc4b05c79b6e15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ComputeCreditsTransactionRow_transaction$data = {
  readonly creditsAmount: string;
  readonly repository: {
    readonly " $fragmentSpreads": FragmentRefs<"RepositoryNameChip_repository">;
  };
  readonly task: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"TaskCreatedChip_task" | "TaskDurationChip_task" | "TaskNameChip_task">;
  };
  readonly timestamp: number;
  readonly " $fragmentType": "ComputeCreditsTransactionRow_transaction";
};
export type ComputeCreditsTransactionRow_transaction$key = {
  readonly " $data"?: ComputeCreditsTransactionRow_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"ComputeCreditsTransactionRow_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ComputeCreditsTransactionRow_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creditsAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskCreatedChip_task"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskDurationChip_task"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskNameChip_task"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RepositoryNameChip_repository"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OwnerTransaction",
  "abstractKey": null
};

(node as any).hash = "0945712b0ca1aeba678905bfc37de611";

export default node;
